import { render, staticRenderFns } from "./FiltersPanelSelectSystem.vue?vue&type=template&id=5b4524cf&scoped=true&"
import script from "./FiltersPanelSelectSystem.vue?vue&type=script&lang=js&"
export * from "./FiltersPanelSelectSystem.vue?vue&type=script&lang=js&"
import style0 from "./FiltersPanelSelectSystem.vue?vue&type=style&index=0&id=5b4524cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4524cf",
  null
  
)

export default component.exports